const playoffCaptainEndpoint =
    '/site/api/playoff-captains' +
    '?include=player.firstName&include=player.lastName&include=player.id' +
    '&sort=[{"property":"seasonId","direction":"DESC"},{"property":"sequence","direction":"ASC"}]';

export default {
    playoffCaptainEndpoint,
};
